import React from "react";
import { useState } from 'react';
import axios from 'axios';


import CallToAction from "../components/general/callToAction";

function Contact() {
    const [formData, setFormData] = useState({
      fname: '',
      email: '',
      phone: '',
      subject: '',
      message: ''
    });
  
    const handleChange = (event) => {
      setFormData({ ...formData, [event.target.id]: event.target.value });
    };
  
    const handleSubmit = (event) => {
      event.preventDefault();
      axios.post('http://localhost/ath-revamp/api/Contact.php', formData, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      
          .then((response) => {
            console.log(response.data);
          })
          .catch((error) => {
            console.error(error);
          });          
    };

  return (
  <>
    {/* <PageHeader title="Contact Us" breadcrumb="Contact" /> */}

    <section className="contact-page-wrap section-padding revamp-header-spacer">
        <div className="container">
            <div className="row">
                <div className="col-lg-4 col-md-6 col-12">
                    <div className="revamp-contact-card">
                        <div className="icon">
                            <i className="fal fa-envelope"></i>
                        </div>
                        <h4>Email Address</h4>
                        <p>hello@abiatechhub.com</p>
                        <a href="mailto:hello@abiatechhub.com" className="d-block mt-3" style={{color: 'var(--revamp-accent-teal)'}}>Send Message <i className="fal fa-arrow-right"></i></a>
                    </div>
                </div>
                <div className="col-lg-4 col-md-6 col-12">
                    <div className="revamp-contact-card">
                        <div className="icon">
                            <i className="fal fa-phone"></i>
                        </div>
                        <h4>Phone Number</h4>
                        <p>+234 805 274 9600</p>
                        <a href="tel:+2348052749600" className="d-block mt-3" style={{color: 'var(--revamp-accent-teal)'}}>Call Now <i className="fal fa-arrow-right"></i></a>
                    </div>
                </div>
                <div className="col-lg-4 col-md-6 col-12">
                    <div className="revamp-contact-card">
                        <div className="icon">
                            <i className="fal fa-map-marker-alt"></i>
                        </div>
                        <h4>Office Address</h4>
                        <p>6, Warri street Umuahia, Abia state.</p>
                        <a href="https://www.google.com/maps?q=Abia+Tech+Hub/" target="_blank" rel="noreferrer" className="d-block mt-3" style={{color: 'var(--revamp-accent-teal)'}}>Get Directions <i className="fal fa-arrow-right"></i></a>
                    </div>
                </div>
            </div>

            <div className="row mt-5">
                <div className="col-12 col-lg-12">
                    <div className="contact-map-wrap">
                        <div id="map" style={{borderRadius: '20px', overflow: 'hidden', border: '1px solid rgba(255,255,255,0.1)'}}>
                          <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3971.2187863554536!2d7.491104674226888!3d5.534532733866766!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1042dcc55f4f0f9d%3A0xf30a6c9bcfab7dfa!2sAbia%20Tech%20Hub!5e0!3m2!1sen!2sng!4v1685530733902!5m2!1sen!2sng"
                          className="w-100"
                          height="450"
                          style={{ border: "0"}}
                          allowFullScreen=""
                          aria-hidden="false"
                          loading="lazy"
                          tabIndex="0"
                          referrerPolicy="no-referrer-when-downgrade"
                          title="Google Maps"
                        ></iframe>  
                        </div>
                    </div>
                </div>
            </div>

            <div className="row section-padding pb-0 justify-content-center">
                <div className="col-12 text-center mb-20">
                    <div className="section-title">
                        <span className="revamp-section-badge">send us message</span>
                        <h1 className="revamp-section-title">Don’t Hesitate To Contact Us <br /> Say Hello</h1>
                    </div>
                </div>

                <div className="col-12 col-lg-8">
                    <div className="revamp-contact-form">                                                        
                        <form action="/api/contact.php" className="row conact-form" onSubmit={handleSubmit}>
                            <div className="col-md-6 col-12">
                                <div className="revamp-form-group">
                                    <label htmlFor="fname" className="revamp-form-label">Full Name</label>
                                    <input type="text" id="fname" name="fname" className="revamp-form-input" placeholder="Enter Name" value={formData.fname} onChange={handleChange} />                                         
                                </div>
                            </div>                            
                            <div className="col-md-6 col-12">
                                <div className="revamp-form-group">
                                    <label htmlFor="email" className="revamp-form-label">Email Address</label>
                                    <input type="email" id="email" name="email" className="revamp-form-input" placeholder="Enter Email Address" value={formData.email} onChange={handleChange} />                                         
                                </div>
                            </div>
                            <div className="col-md-6 col-12">
                                <div className="revamp-form-group">
                                    <label htmlFor="phone" className="revamp-form-label">Phone Number</label>
                                    <input type="text" id="phone" name="phone" className="revamp-form-input" placeholder="Enter Number" value={formData.phone} onChange={handleChange} />                                         
                                </div>
                            </div>                                      
                            <div className="col-md-6 col-12">
                                <div className="revamp-form-group">
                                    <label htmlFor="subject" className="revamp-form-label">Subject</label>
                                    <input type="text" id="subject" name="subject" className="revamp-form-input" placeholder="Enter Subject" value={formData.subject} onChange={handleChange} />                                         
                                </div>
                            </div>                                      
                            <div className="col-md-12 col-12">
                                <div className="revamp-form-group">
                                    <label htmlFor="message" className="revamp-form-label">Enter Message</label>
                                    <textarea id="message" name="message" className="revamp-form-input" placeholder="Enter message" value={formData.message} onChange={handleChange} ></textarea>                                        
                                </div>
                            </div>                                      
                            <div className="col-md-12 col-12 text-center">
                                <button type="submit" className="theme-btn">send message <i className="fas fa-arrow-right"></i></button>
                            </div>                                      
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
    
    <CallToAction />
  </>
  );
}

export default Contact;